"use client";

import React from "react";
import ServicesCarousel from "./services-carousel";
import { SanityDocument } from "next-sanity";
import SectionHeader from "@components/common/section-header";

interface ServicesOfferedProps {
  services: SanityDocument[];
}

function ServicesOffered({ services }: Readonly<ServicesOfferedProps>) {
  return (
    <section className="min-h-screen w-full bg-gradient-to-b from-slate-800 to-slate-900 px-5 py-8 text-white md:px-10 lg:py-20">
      <SectionHeader
        title="Elevate Your Projects, Drive Innovation!"
        highlightedTitle="Our Commitment:"
        bodyText="At Rake Engineering Consultancy , we elevate engineering and consultancy through a seamless blend of innovation, precision, and expertise. Our dedicated team is committed to delivering customized solutions that redefine industry standards and drive success."
        triggerStart="50"
      />

      <ServicesCarousel services={services} pathname="/services" />
    </section>
  );
}

export default ServicesOffered;
